<template>
  <div class="form-contact row-1 p-top-0 p-bot-2">
    <div class="form-contact__company-info">
      <div class="title-base">
        <div class="form-contact__company-info__title is-medium-bold">
          <h1>Bioenologia 2.0 s.r.l.</h1>
        </div>
        <div class="is-light">
          <p class="pre-line">{{ $t('contatti.info') }}</p>
          <a
            href="https://maps.app.goo.gl/aYiX8a4dAqGfypfg6"
            target="_blank"
            rel="noopener noreferrer"
            class="maps-link reverse-underline-hover"
          >
            <MapsIcon alt="Google Maps Icon" />
            <span>Google Maps</span>
          </a>
        </div>
      </div>
      <div class="title-base">
        <div class="form-contact__company-info__title secondary is-medium-bold">
          <h2 v-html="$t('navigation.contacts')" />
        </div>
        <div class="is-light">
          Tel. <a href="tel:+390422815518">+39 0422 815518</a><br />
          Fax +39 0422 716302<br />
          <a href="mailto:info@bioenologia.com">info@bioenologia.com</a>
        </div>
      </div>
      <!--
      <div>
        <div
          class="form-contact__company-info__title title-base is-medium-bold"
        >
          <h2 v-html="$t('contatti.teamTitle')" />
        </div>
        <div class="text-medium5">
          <p class="pre-line">{{ $t('contatti.teamText') }}</p>
        </div>
      </div>
    --></div>
    <div class="form-contact__form">
      <FormKit
        v-model="requestData"
        type="form"
        :actions="false"
        @submit="onSubmit"
        id="requestForm"
      >
        <div class="form-contact__grid">
          <!-- Name -->
          <FormKit
            type="text"
            name="name"
            validation="required"
            :label="$t('form.name')"
            id="input_name"
            autocomplete="given-name"
          />

          <!-- Surname -->
          <FormKit
            type="text"
            name="surname"
            validation="required"
            :label="$t('form.surname')"
            id="input_surname"
            autocomplete="family-name"
          />

          <!-- Email -->
          <FormKit
            type="email"
            name="email"
            validation="required|email"
            :label="$t('form.email')"
            id="input_email"
            autocomplete="email"
          />

          <!-- Telephone -->
          <FormKit
            type="text"
            name="telephone"
            validation="required"
            :label="$t('form.phone')"
            id="input_telephone"
            autocomplete="tel"
          />

          <!-- City -->
          <FormKit
            type="text"
            name="city"
            validation="required"
            :label="$t('form.city')"
            id="input_city"
            autocomplete="address-level2"
          />

          <!-- Role -->
          <FormKit
            type="select"
            name="options"
            select-icon="down"
            :label="$t('form.role')"
            :options="$t('form.roles').split(',')"
            id="input_role"
            autocomplete="organization-title"
          />

          <!-- Request Type -->
          <FormKit
            type="select"
            name="requestType"
            select-icon="down"
            :label="$t('form.requestType')"
            :options="$t('form.requests').split(',')"
            id="input_requestType"
            autocomplete="off"
          />

          <!-- Company -->
          <FormKit
            type="text"
            name="company"
            :label="$t('form.company')"
            id="input_company"
            autocomplete="organization"
          />

          <!-- Messaggio -->
          <FormKit
            type="textarea"
            name="message"
            rows="7"
            :label="$t('form.message')"
            id="input_message"
            autocomplete="off"
          />
        </div>

        <!-- CHECKBOX Privacy -->
        <FormKit
          type="checkbox"
          name="terms"
          validation="accepted"
          :validation-messages="{ accepted: $t('form.termsError') }"
          id="input_terms"
          autocomplete="off"
        >
          <template #label="context">
            <p
              class="text-small3"
              v-html="
                $t('form.termsExtLabel', {
                  url: localePath({
                    name: 'privacy-policy',
                  }),
                })
              "
            />
          </template>
        </FormKit>

        <!-- CHECKBOX Newsletter -->
        <!-- 
        <FormKit
          type="checkbox"
          name="newsletter"
          id="input_newsletter"
          autocomplete="off"
        >
          <template #label="context">
            <p class="text-small3" v-html="$t('form.newsletterExtLabel')" />
          </template>
        </FormKit>
        -->

        <p class="text-small3" v-html="$t('form.endMessage')" />

        <div class="form-contact__cta">
          <button type="submit" class="round-icon-btn">
            {{ $t('form.sendRequest') }}
          </button>
        </div>

        <div class="form-contact__messages">
          <div v-if="successMessage" class="success-message">
            {{ $t('form.success') }}
          </div>
          <div v-if="errorMessage" class="error-message">
            {{ $t('form.error') }}
          </div>
        </div>
      </FormKit>
    </div>
  </div>
</template>

<script setup>
import { load } from 'recaptcha-v3'
import { reset } from '@formkit/core'
import MapsIcon from '@/assets/img/ico/google-maps.svg'

const emit = defineEmits(['contacts-success', 'contacts-failure'])

const props = defineProps({
  contatti: Object,
})

const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()

const requestData = ref(null)
const loading = ref(false)
const successMessage = ref(false)
const errorMessage = ref(false)

const postinApiId = t('form.apiContactFormPostinId')

const onSubmit = (formkitData, node) => {
  node.clearErrors()

  loading.value = true
  successMessage.value = false
  errorMessage.value = false

  load(runtimeConfig.public.recaptchaKey).then((recaptcha) => {
    recaptcha.hideBadge()

    recaptcha.execute('postin').then((token) => {
      const formData = new FormData()

      formData.append('captcha', token)
      formData.append('api_id', postinApiId)

      formData.append('name', formkitData.name)
      formData.append('surname', formkitData.surname)
      formData.append('email', formkitData.email)
      formData.append('telephone', formkitData.telephone)
      formData.append('city', formkitData.city)
      formData.append('options', formkitData.options)
      formData.append('requestType', formkitData.requestType)
      formData.append('company', formkitData.company)
      formData.append('message', formkitData.message)

      formData.append('newsletter', formkitData.newsletter)

      // ID del template mail di postin
      fetch(runtimeConfig.public.postinURL, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          loading.value = false

          if (response.status === 200) {
            successMessage.value = true
            emit('contacts-success')
            reset(node)
          } else {
            errorMessage.value = true
            emit('contacts-failure')
          }
        })
        .catch((e) => {
          loading.value = false
          errorMessage.value = true
          emit('contacts-failure')
        })
    })
  })
}
</script>

<script>
export default {
  name: 'FormContact',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
